// extracted by mini-css-extract-plugin
export default {"container":"bC-z","brandName":"cC-z","productName":"dC-z","aboveGalleryInfo":"eC-z","belowGalleryInfo":"fC-z","breakLongProductName":"gC-z"};